import Vue from 'vue';
import Default from './Default';
import Empty from './Empty';

Vue.component('empty-layout', Empty);
Vue.component('default-layout', Default);
